import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function MomSysUdtMaterialType ( props ) {

    return <BasicCrudScreenType id="MomSysUdtMaterialType" table="MomSysUdtMaterialType" view="MomSysVwMaterialType" />;

}

export default MomSysUdtMaterialType;
